var _rect, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlowingStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "ext1_1",
    x: 0.273438,
    width: 40,
    height: 40,
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ext1_1_i",
    d: "M30.0075 21.7521L27.6768 21.9125C27.051 21.9583 26.7929 22.7219 27.27 23.1189L29.0611 24.585C29.4522 24.9057 30.0466 24.7377 30.2031 24.2643L30.7349 22.6684C30.8992 22.195 30.5159 21.714 30.0075 21.7521Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "ext1_1_i",
    d: "M24.5855 11.0186L24.0455 13.1936C23.8955 13.7786 24.5405 14.2511 25.0505 13.9286L26.9555 12.7436C27.368 12.4886 27.3905 11.8886 26.993 11.6036L25.658 10.6361C25.2605 10.3436 24.7055 10.5461 24.5855 11.0186Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "ext1_1_i",
    d: "M13.0964 12.746L14.9939 13.931C15.5039 14.2535 16.1488 13.7885 16.0063 13.196L15.4664 11.021C15.3464 10.5485 14.7914 10.346 14.3939 10.631L13.0589 11.5985C12.6614 11.8985 12.6839 12.491 13.0964 12.746Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "ext1_1_i",
    d: "M11.4124 24.5346L13.1299 23.0946C13.5949 22.7046 13.3474 21.9471 12.7474 21.9096L10.5124 21.7521C10.0249 21.7146 9.65737 22.1871 9.80737 22.6521L10.3174 24.2196C10.4674 24.6846 11.0449 24.8496 11.4124 24.5346Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "ext1_1_i",
    d: "M21.6199 30.0035L20.7799 27.926C20.5549 27.3635 19.7599 27.3635 19.5349 27.926L18.6949 30.0035C18.5149 30.4535 18.8449 30.9485 19.3324 30.9485H20.9824C21.4699 30.941 21.7999 30.4535 21.6199 30.0035Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "ext1_1_i",
    d: "M21.4468 11.4932L22.7419 14.2829C22.9862 14.8037 23.4672 15.1682 24.0297 15.25L27.0714 15.7187C28.4479 15.927 29.0029 17.6157 28.0408 18.6126L25.7244 21.0006C25.347 21.3875 25.1768 21.938 25.2656 22.4736L25.7984 25.7544C26.0279 27.1678 24.5329 28.2242 23.2822 27.5324L20.729 26.1114C20.2109 25.8213 19.5893 25.8213 19.0712 26.1114L16.518 27.5324C15.2673 28.2242 13.7723 27.1678 14.0017 25.7544L14.5346 22.4736C14.6234 21.938 14.4532 21.3875 14.0757 21.0006L11.7593 18.6126C10.7898 17.6083 11.3523 15.927 12.7288 15.7187L15.7705 15.25C16.3329 15.1607 16.814 14.7962 17.0582 14.2829L18.3533 11.4932C18.9676 10.1689 20.8326 10.1689 21.4468 11.4932Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlowingStar);
export default __webpack_public_path__ + "static/media/GlowingStar.f834bf65.svg";
export { ForwardRef as ReactComponent };